import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css/effect-fade";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import Home_banner from "./home_banner/Home_banner";
import ScrollAnimation from "react-animate-on-scroll";

function Banner({ banner }) {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: false,
      startEvent: "DOMContentLoaded",
      mirror: true,
      offset: 0,
    });
    AOS.refresh();
  }, []);

  // AOS.init({ disable: 'mobile' });

  return (
    <section
      className="Banner"
      // data-aos="zoom-in"
      // data-aos-duration="2000"
    >
      <Swiper
        spaceBetween={15}
        pagination={{
          dynamicBullets: true,
          clickable: true,
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Pagination]}
        className="banner_swiper"
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
        }}
      >
        {banner?.map((val) => (
          <SwiperSlide>
            <div className="img_holder">
              <img
                src={process.env.REACT_APP_IMG_URL + val?.image}
                className="image"
              />
            </div>
          </SwiperSlide>

          // old code
          // <SwiperSlide>
          //   <div className="banner-zoom">
          //     <Home_banner val={val} />
          //   </div>
          // </SwiperSlide>
        ))}

        {/* <SwiperSlide>
          <Home_banner />
        </SwiperSlide>
        <SwiperSlide>
          <Home_banner />
        </SwiperSlide> */}
      </Swiper>
    </section>
  );
}

export default Banner;
